export default __webpack_public_path__ + "static/media/slide11.9e5a7963.jpg";